//redux
import { RootState, useAppDispatch } from '../Redux/store';
import { useSelector } from 'react-redux';

import { 
    login as loginThunk,
    clearErrors as clearErrorAction,
    setToken,
    clearAuth,
    setLoginError as setLoginErrorRedux,
    loginWithExistingToken as loginWithExistingTokenRedux,
    loginFromAuthTokenResponse
} from '../Redux/slices/authSlice';


//services and utilities
import tokenStorageService from '../services/TokenStorageService';
import { isTokenExpired as checkTokenIsExpired, parseLocalStorageJwt } from '../utility/auth';
import { logOut } from '../services/authservice';
import { AxiosResponse } from 'axios';

const useAuth = () => {

    const dispatch = useAppDispatch();
    const { authDetails, isLoggedIn, status, error, token} = useSelector((state: RootState) => state.auth);

    function setAuthFromLocalStorage() {
        const token = tokenStorageService.getItem('token')
        if (token && !checkTokenIsExpired(token) && parseLocalStorageJwt(token as string)) {
            dispatch(setToken(tokenStorageService.getItem('token')))
        }
        else {
            tokenStorageService.removeItem('token')
        };
    }

    function login(userName: string, password: string){
        dispatch(loginThunk({userName, password}));
    }

    function clearErrors(){
        dispatch(clearErrorAction())
    }

    function isTokenExpired(): boolean {
        return checkTokenIsExpired(token || localStorage.getItem('token'))
    }

    function logoutRedux(params?: { noRedirect?: boolean, keepOrgName?: boolean }) {
        dispatch(clearAuth())
        logOut(params)
    }

    function setLoginError(err: AxiosResponse) {
        dispatch(setLoginErrorRedux(err))
    }

    function loginWithExistingToken(data: any, userName:string) {
        dispatch(loginWithExistingTokenRedux(loginFromAuthTokenResponse(data, userName)))
    }

    return {
        login,
        clearErrors,
        setAuthFromLocalStorage,
        isTokenExpired,
        logoutRedux,
        setLoginError,
        loginWithExistingToken,
        authDetails,
        isLoggedIn,
        status,
        error,
        token
    }
};

export default useAuth;